export default __webpack_public_path__ + "static/media/erigon-bg.ed163d2b.png";